<template>
  <div class="bg-light">
    <div class="container-fluid py-2 styleheader">
      <div class="row">
        <div class="col-12 col-lg-5">
          <div class="d-flex align-items-center">
            <button class="btn btn-label text-black" style="outline: none; box-shadow: none;" @click="$router.push('/')">
              <img
                src="@/assets/statics/smartmatic-logo.svg"
                class="d-inline-block align-text-top"
                width="218"
              >
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-7 ps-2 m-0 d-flex justify-content-end align-items-center">
          <div class="d-flex justify-content-between align-items-center">

            <div title="About">
              <button class="btn btn-link text-black" @click="modal.show()">
                <i class="bi bi-info-circle"></i>
              </button>
            </div>

            <div title="Service Desk" class="dropdown p-0 m-0">
              <a
                class="btn btn-link remove-dropdown-arrow dropdown-toggle text-black"
                target="_blank" href="https://mobile-support.smartmaticservices.net"
                role="button"
              >
                <i class="bi bi-question-circle"></i>
              </a>
            </div>

            <div title="Notifications">
              <button class="btn btn-link text-black" @click="$router.push('/notifications')">
                <i class="bi bi-bell-fill"></i>
              </button>
            </div>

            <div v-if="user.is_admin" class="dropdown" title="System Administration">
              <button class="btn btn-link remove-dropdown-arrow dropdown-toggle text-black" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <p class="btn btn-link text-decoration-none text-black p-0 m-0">
                  <i class="bi bi-gear-fill"></i>
                </p>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" @click="$router.push('/user/management')">Users</a>
                </li>
                <li>
                  <a class="dropdown-item" @click="$router.push('/site/management')">Sites</a>
                </li>
                <li>
                  <a class="dropdown-item" @click="$router.push('/site/type/management')">Types</a>
                </li>
                <li>
                  <a class="dropdown-item" @click="$router.push('/notifications/management')">Notifications</a>
                </li>
              </ul>
            </div>

            <div class="dropdown px-2 m-0">
              <button class="btn btn-link dropdown-toggle text-black p-0 m-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <p class="btn btn-link text-decoration-none text-black p-0 m-0">
                  {{ user.username || ''}}
                </p>
              </button>
              <ul class="dropdown-menu dropdown-menu-end p-2">
                <li>
                  <a
                    class="nav-link active" 
                    @click="handleLogout"
                    role="button"
                  >
                    <i class="bi bi-box-arrow-right"></i>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal fade" ref="Modal" tabindex="-1" aria-labelledby="ModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="ModalLabel">Version</h1>
                <button type="button" class="btn-close" @click="modal.hide()" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-center">2.0.6</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid pb-2">
      <button
        v-if="showBackButton"
        @click="$router.back()"
        class="btn btn-label"
      >
        <i class="bi bi-arrow-left"></i> Go Back
      </button>
      <p v-else class="main-title p-4 m-0">
        Smart e360
      </p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Modal } from 'bootstrap';
export default {
  data: () => ({
    modal: null
  }),
  computed: {
    ...mapState(['user']),
    showBackButton() {
      return this.$route.name !== 'Home'
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.Modal)
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout() {
      this.logout()
      this.$router.push('/login')
    }
  },
}
</script>
<style scoped>
.main-title {
  padding-left: 12px!important;
  font-size: calc(24px + .25vw);
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
}

.styleheader {
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  -webkit-box-shadow: inset 0 -1px 0 0 #e0e0e0;
  box-shadow: inset 0 -1px 0 0 #e0e0e0;
  background-color: #FFF;
}

#menu::before, #menu::after {
  content: '';
  visibility: visible;
}
.dropdown-toggle.remove-dropdown-arrow::after {
  content: none;
}
</style>